import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["copyButton", "label"]
    static values = { messageId: Number }

    async copy() {
        // 最後のAIメッセージの内容をコピー
        const messageEl = document.getElementById(`message_content_${this.messageIdValue}`)
        const text = messageEl ? messageEl.innerText : ""

        if (!text) {
            this.labelTarget.textContent = "コピーする内容がありません"
            return
        }

        try {
            await navigator.clipboard.writeText(text)
            this.labelTarget.textContent = "✓ コピーしました！"
            this.copyButtonTarget.classList.add("bg-green-50", "dark:bg-green-900/20", "border-green-300", "dark:border-green-700")
            setTimeout(() => {
                this.labelTarget.textContent = "要約をコピー"
                this.copyButtonTarget.classList.remove("bg-green-50", "dark:bg-green-900/20", "border-green-300", "dark:border-green-700")
            }, 2000)
        } catch {
            // Fallback for older browsers
            const textarea = document.createElement("textarea")
            textarea.value = text
            textarea.style.position = "fixed"
            textarea.style.opacity = "0"
            document.body.appendChild(textarea)
            textarea.select()
            document.execCommand("copy")
            document.body.removeChild(textarea)
            this.labelTarget.textContent = "✓ コピーしました！"
            setTimeout(() => { this.labelTarget.textContent = "要約をコピー" }, 2000)
        }
    }
}
